import { push } from "react-router-redux";

const dispatchAndGoTo = dispatch => (action, href) => {
  dispatch(action);
  dispatch(push(href));
};

const goTo = dispatch => href => {
  dispatch(push(href));
};

const onLinkClick = dispatch => event => {
  event.preventDefault();
  const href = event.target.attributes.href.value;
  dispatch(push(href));
};

const onGlyphButtonClick = dispatch => event => {
  event.preventDefault();
  const target = event.target;
  // Here, target is either the link (<a/>, or the glyph  - which is a child of the link.
  // If the target is the glyph, then that won't have a href.
  const targetIsGlyph = !event.target.attributes.href;
  const glyph = targetIsGlyph ? target : undefined;
  const link = targetIsGlyph ? glyph.parentNode : target;
  const href = link.attributes.href.value;
  dispatch(push(href));
};

const onGlyphButtonClickDispatch = dispatch => action => event => {
  event.preventDefault();
  dispatch(action);
};

const onGlyphButtonClickExternal = event => {
  event.preventDefault();
  const target = event.target;
  // Here, target is either the link (<a/>, or the glyph  - which is a child of the link.
  // If the target is the glyph, then that won't have a href.
  const targetIsGlyph = !event.target.attributes.href;
  /* istanbul ignore next */
  const glyph = targetIsGlyph ? target : undefined;
  /* istanbul ignore next */
  const link = targetIsGlyph ? glyph.parentNode : target;
  const href = link.attributes.href.value;
  const newWindow = window.open(href, "_blank", "noopener,noreferrer");
  /* istanbul ignore next */
  if (newWindow) newWindow.opener = null;
};

const Navigator = function() {
  this.init = dispatch => {
    this.dispatch = dispatch;
    this.goTo = goTo(dispatch);
    this.dispatchAndGoTo = dispatchAndGoTo(dispatch);
    this.onLinkClick = onLinkClick(dispatch);
    this.onGlyphButtonClick = onGlyphButtonClick(dispatch);
    this.onGlyphButtonClickDispatch = onGlyphButtonClickDispatch(dispatch);
    this.onGlyphButtonClickExternal = onGlyphButtonClickExternal;
  };
};

export default new Navigator();



// WEBPACK FOOTER //
// ./src/sc/helpers/navigation.js